import React, { ComponentProps } from 'react';

import { BaseButton } from '@common/components';

type BaseProps = ComponentProps<typeof BaseButton>;

/**
 * @deprecated Use `Button` from `@common/components` instead.
 */
export const SecondaryButton = (props: Omit<BaseProps, 'type'>) => (
  <BaseButton {...props}>{props.children}</BaseButton>
);
